import { render, staticRenderFns } from "./quick-reply-visual-panel.vue?vue&type=template&id=f7804c6a&scoped=true"
import script from "./quick-reply-visual-panel.vue?vue&type=script&lang=js"
export * from "./quick-reply-visual-panel.vue?vue&type=script&lang=js"
import style0 from "./quick-reply-visual-panel.vue?vue&type=style&index=0&id=f7804c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7804c6a",
  null
  
)

export default component.exports